import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Portal,
} from '@chakra-ui/react';
import { ChevronDown } from '@kula-ai/icons-core';
import { NodeViewWrapper } from '@tiptap/react';
import { useState } from 'react';
import './surveyEditor.scss';
import { Text } from '@kula-ai/components';
import { useSurveyList } from '@/hooks/useSurvey';

// This component will be rendered inline in the editor
export const SurveySelectComponent = ({
  node,
  updateAttributes,
  deleteNode, // eslint-disable-line
  extension,
}) => {
  const { data: surveyOptions } = useSurveyList();

  const { surveyId } = node.attrs;
  const selectedSurvey = JSON.parse(
    localStorage.getItem('editorSelectedSurvey')
  );
  const [searchValue, setSearchValue] = useState('');
  const handleSelect = (value) => {
    const el = document.querySelector('.editor-survey-select-container');
    if (el) {
      el.classList.remove('empty-survey-placeholder-error');
    }
    updateAttributes({ surveyId: value });

    // Get the selected item details
    const selectedItem =
      surveyOptions?.find((opt) => opt.value === value) || null;

    // Call the callback if provided
    if (extension?.options?.onSurveySelect && selectedItem) {
      extension.options.onSurveySelect(selectedItem);
    }

    setSearchValue(''); // Reset search after selection
  };

  const handleMenuClose = () => {
    setSearchValue(''); // Reset search when menu closes
  };

  // Filter options based on search value
  const filteredOptions =
    surveyOptions?.filter((option) =>
      option.label.toLowerCase().includes(searchValue.toLowerCase())
    ) || [];

  const currentValue =
    surveyOptions?.find((opt) => opt.value === surveyId) || null;

  return (
    <NodeViewWrapper
      as="span"
      contentEditable={false}
      style={{ display: 'inline-block' }}
    >
      <Box
        className="editor-survey-select-container"
        display="inline-block"
        data-test-id="survey-select-inline"
        onClick={(e) => e.stopPropagation()}
      >
        <Menu isLazy placement="auto" onClose={handleMenuClose}>
          <MenuButton
            as={Button}
            rightIcon={
              <ChevronDown
                size={18}
                color="var(--kula-colors-primary-600, #605AFB)"
                className="kula-icon editor-survey-select-color"
                style={{ marginLeft: '-5px' }}
              />
            }
            size="sm"
            bg="#DEE4FF"
            className="editor-survey-select-color editor-survey-select-bg-color"
            color="var(--kula-colors-primary-600, #605AFB)"
            fontWeight="550"
            fontSize="14px"
            width="100%"
            textAlign="left"
            _hover={{ bg: '#D0D9FF' }}
            _active={{ bg: '#C2CCFF' }}
            height="auto !important"
            p="5px !important"
          >
            {currentValue?.label || selectedSurvey?.label || 'Select a survey'}
          </MenuButton>
          {/* Portalled: inline it is a child of the scrolling form body and
              gets clipped. zIndex clears the 1400 dialog band. */}
          <Portal>
            <MenuList
              zIndex="1500"
              // Fixed, not `minWidth`: it sized to the longest survey name
              // and could span the dialog. Long names truncate instead.
              width="320px"
              maxWidth="320px"
              maxH="300px"
              overflowY="auto"
              borderColor="border-color"
              borderWidth="1px"
              borderRadius="8px"
              boxShadow="0px 4px 12px rgba(0, 0, 0, 0.08)"
              p="0"
              m="0"
            >
              {filteredOptions?.length > 0 ? (
                filteredOptions?.map((option) => (
                  <MenuItem
                    key={option.value}
                    onClick={() => handleSelect(option.value, option.label)}
                    bg="white"
                    _hover={{ bg: '#F8F9FC' }}
                    _focus={{ bg: '#F8F9FC' }}
                    py="10px"
                    px="12px"
                    borderBottom="1px solid"
                    borderColor="border-color"
                    borderRadius="0"
                    _last={{ borderBottom: 'none' }}
                  >
                    {/* `minW={0}` is load-bearing: without it a flex child
                        will not shrink, so the ellipsis never appears. */}
                    <Box minW={0} width="100%">
                      <Text
                        variant="small"
                        color="body"
                        truncate
                        tooltip
                        style={{ display: 'block', width: '100%' }}
                      >
                        {option.label}
                      </Text>
                    </Box>
                  </MenuItem>
                ))
              ) : (
                <Box px="3" py="2" color="gray.500" fontSize="sm">
                  No surveys found
                </Box>
              )}
            </MenuList>
          </Portal>
        </Menu>
      </Box>
    </NodeViewWrapper>
  );
};
